import { InterectionEntityWithVehicleInfo } from "../utils";

/**
 * Gets the mission name from an intersection item
 * @param data - Intersection data with vehicle information
 * @returns The mission name or "No mission" if no mission exists
 */
export function getMissionName(data: InterectionEntityWithVehicleInfo): string {
  return data.mission_name || "No mission";
}

/**
 * Gets the mission name with custom fallback
 * @param data - Intersection data with vehicle information
 * @param fallbackText - Custom fallback text
 * @returns The mission name or fallback text if no mission exists
 */
export function getMissionNameWithFallback(
  data: InterectionEntityWithVehicleInfo,
  fallbackText = "No mission"
): string {
  return data.mission_name || fallbackText;
}

/**
 * Checks if the item has an active mission
 * @param data - Intersection data with vehicle information
 * @returns true if there is a mission, false otherwise
 */
export function hasActiveMission(
  data: InterectionEntityWithVehicleInfo
): boolean {
  return Boolean(data.mission_name);
}
